import React from 'react';
import Chart from './components/Chart';
import CallToAction from './call_to_action.svg';
import './App.css';

class App extends React.Component {

  state = {
    categories: [
      'Resource Use Score','Emissions Score','Innovation Score',
      'CSR Strategy Score','Community Score','Human Rights Score','Product Responsibility Score',
      'Shareholders Score','Management Score','Workforce Score','ESG Controversies Score'
    ],
    data: {},
    dataHash: {},
    prevYrDataHash: {},
    render: false,
    year: '',
  }

  componentDidMount(){
    this.fetchFranchiseHeroData()
  }

  grabRicFromUrl() {
    var url = window.location.href
    var vars = {};
    if (url.includes("?")){
      var hashes = url.split("?")[1]
      var hash = hashes.split('&')
      for (var i = 0; i < hash.length; i++) {
        var params = hash[i].split("=")
        vars[params[0]] = params[1]
      }
      return vars["ric"]
    } else {
      return null
    }
  }

  fetchFranchiseHeroData = () => {
    fetch(`https://refinitiv-cdn.fortune.com/${this.grabRicFromUrl()}_fortune_refinitiv.json`)
    .then(res => res.json())
    .then(esgData => {
      if (esgData.links.count > 1) {
        //create hash of previous year's ESG data
        var prevYrScores = esgData.data[1].slice(2,18)
        var prevYrScoreLabels = esgData.headers.slice(2,18).map(headers => headers.title)
        var prevYrDataHash = {}
        for (let i = 0; i < prevYrScores.length; i++){
          prevYrDataHash[prevYrScoreLabels[i]] = Math.round(prevYrScores[i])
        } 
        //create hash of this year's ESG data
        var year = parseInt(esgData.data[0][1])
        var scores = esgData.data[0].slice(2,18)
        var scoreLabels = esgData.headers.slice(2,18).map(headers => headers.title)
        var dataHash = {}
        for (let i = 0; i < scores.length; i++){
          dataHash[scoreLabels[i]] = Math.round(scores[i])
        }
        let chartScores = []
        for(let i = 0; i < this.state.categories.length; i ++){
          chartScores.push(dataHash[this.state.categories[i]])
        }
        //set state with data
        this.setState({
          data: {
            labels: this.state.categories,
            datasets: [{
              data: chartScores,
              backgroundColor: [
                'rgb(37,170,79,0.7)','rgb(37,170,79,0.7)','rgb(37,170,79,0.7)',
                'rgb(251,60,45,0.7)','rgb(251,60,45,0.7)','rgb(251,60,45,0.7)','rgb(251,60,45,0.7)',
                'rgb(74,131,192,0.7)','rgb(74,131,192,0.7)','rgb(74,131,192,0.7)','rgb(74,131,192,0.7)'
              ]
            }]
          },
          dataHash: dataHash,
          prevYrDataHash: prevYrDataHash,
          render: true,
          year: year,
        })
      } else if (esgData.links.count > 0) {
        var year = parseInt(esgData.data[0][1])
        var scores = esgData.data[0].slice(2,18)
        var scoreLabels = esgData.headers.slice(2,18).map(headers => headers.title)
        var dataHash = {}
        for (let i = 0; i < scores.length; i++){
          dataHash[scoreLabels[i]] = Math.round(scores[i])
        }
        let chartScores = []
        for(let i = 0; i < this.state.categories.length; i ++){
          chartScores.push(dataHash[this.state.categories[i]])
        }
        this.setState({
          data: {
            labels: this.state.categories,
            datasets: [{
              data: chartScores,
              backgroundColor: [
                'rgb(228,190,98,0.5)','rgb(228,190,98,0.5)','rgb(228,190,98,0.5)',
                'rgb(191,191,191,0.5)','rgb(191,191,191,0.5)','rgb(191,191,191,0.5)','rgb(191,191,191,0.5)',
                'rgb(81,160,227,0.5)','rgb(81,160,227,0.5)','rgb(81,160,227,0.5)','rgb(81,160,227,0.5)'
              ]
            }]
          },
          dataHash: dataHash,
          render: true,
          year: year,
        })
      }
    })
  }

  render() {

    return (
      <div className="App">
        { this.state.render
            ?
            <div className="RefinitivContainer">
              <div className="CallToAction">
                <img src={CallToAction} alt="gray question mark" width={18} height={18} />
                <span className="SLMDescription">The sustainable leadership monitor from Refinitiv helps users answer questions around long-term sustainable growth and gain situational awareness through an intuitive interface, analytics and a bedrock of transparent and standardized ESG/Financial data.</span>
              </div>
              <Chart data={this.state.data} dataHash={this.state.dataHash} prevYrDataHash={this.state.prevYrDataHash} />
              <p className="FYNote">Fiscal Year {this.state.year}{'\n'}Source: Refinitiv</p>
            </div>
            :
          null
        }
      </div>
    );
  }
}

export default App;
